import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getTutorials = () =>
  axiosInstance.get(`${LANDING_API_URL}/landing-toturials`, {
    headers: authHeaders(),
  });

export const createTutorialRequest = (tutorialData) =>
  axiosInstance.post(`${LANDING_API_URL}/landing-toturials`, tutorialData, {
    headers: authHeaders(),
  });

export const updateTutorialRequest = (tutorialId, tutorialData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/landing-toturials/${tutorialId}`,
    tutorialData,
    {
      headers: authHeaders(),
    },
  );

export const removeTutorial = (tutorialId) =>
  axiosInstance.delete(`${LANDING_API_URL}/landing-toturials/${tutorialId}`, {
    headers: authHeaders(),
  });
